module.exports = __webpack_public_path__ + "img/TOSOLA_hero.a59d4715.png";